import styled from "styled-components";
import { Navbar, Image, Container } from "react-bootstrap";
import closeup from "./../assets/closeup.png";

export const LandingPageButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
`;

export const StyledNavbar = styled(Navbar)`
  position: sticky;
  top: 0;
  z-index: 999;
  background-color: #f8f1ea;
`;

export const StyledAvatar = styled(Image)`
object-fit: cover;
  width: 200px;
  height: 200px;
  // border-radius: 50%;
  margin: 1rem;
`;

export const ButtonsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  border-bottom: 1px solid #eee;
`;

export const BackgroundImage = styled.div`
  background-image: url(${closeup});
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  position: absolute;
  top: 0%;
  left: 0%;
  height: 70vh;
  width: 100vw;
  z-index: -1;
`;

